import React, { useEffect, useMemo, useState } from "react";
import { OrganizationUserService, OrganizationUserVM } from "@propertelligent/client-api";

import ResetPasswordModal from "./ResetPasswordModal";
import "./MyProfile.css";
import EditProfileComponent from "./EditProfileComponent";
import { UserLoginData } from "../../common/charts/Enums";
import apiHelper from "../../../utils/apiHelper";
import ActionMenu from "../../../newComponents/actionMenus/action-menu";
import EditProfileModal from "./EditProfileComponent";
import { GetImages } from "../../../utils/GetImages";
import dropdownIcon from "../../../assets/componentsIcons/dropdown/dropdown.svg";
import editIcon from "../../../assets/componentsIcons/dropdown/edit.svg";
import lockIcon from "../../../assets/lockIcon.svg";
import SimpleSpinner from "../../loader";

// Permission support
import { usePermissions } from "../../../hooks/usePermissions";
import { PermissionGuard } from "../../../newComponents/PermissionGuard";
import NoAccess from "../../../pages/NoAccess";
import { AccessLevelEnum } from "@propertelligent/client-api";

const MyProfileComponent = () => {
  const [userData, setUserData] = useState<OrganizationUserVM | null>(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);

  const check = usePermissions();
  const canWrite = check.canWrite("MyProfile");

  const userId = parseInt(sessionStorage.getItem("organizationUserId") || "0");

  const fetchProfile = async () => {
    setLoading(true); // Start loading
    try {
      const res = await apiHelper(OrganizationUserService.getApiOrganizationUser, { showNotification: false }, userId);
      if (res?.data?.success) {
        setUserData(res.data.success);
      }
    } catch (error) {
      console.error("Failed to fetch profile", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchProfile(); }, []);

  // Action Menu Items for Basic Details
  const basicDetailsActions = useMemo(() => [
    {
      icon: editIcon,
      label: "Edit Profile",
      action: () => setShowEditModal(true),
    }
  ], []);

  // Action Menu Items for Security
  const securityActions = useMemo(() => [
    {
      icon: lockIcon,
      label: "Reset Password",
      action: () => setShowResetModal(true),
    }
  ], []);




  return (
    <PermissionGuard permission="MyProfile" level={AccessLevelEnum.ReadOnly} fallback={<NoAccess />}>
      <div className="profile-container container-fluid">
        <h2 className="page-title">My Profile</h2>

      {loading ? (
        <SimpleSpinner />
      ) : (
        <>
          {/* Basic Details Section */}
          <div className="profile-card mb-4">
            <div className="card-header-flex">
              <h5 className="section-title black">Basic Details</h5>
              {canWrite && (
              <ActionMenu
                trigger={<img src={dropdownIcon} alt="Options" width={26} height={26} className="pointer iconStyleWithWhiteFilter" />}
                menuItems={basicDetailsActions}
                Id={userId}
              />
              )}
            </div>

            <div className="details-grid mt-3">
              <div className="profile-detail-item">
                <label>Full Name</label>
                <p><i className="bi bi-person me-2"></i>{userData?.fullName || "---"}</p>
              </div>
              <div className="profile-detail-item">
                <label>Email:</label>
                <p><i className="bi bi-envelope me-2"></i>{userData?.email || "---"}</p>
              </div>
              <div className="profile-detail-item">
                <label>Contact No:</label>
                <p><i className="bi bi-telephone me-2"></i>{userData?.formatted?.PhoneNumber || "---"}</p>
              </div>
            </div>
          </div>

          {/* Security Section */}
          <div className="profile-card">
            <div className="card-header-flex">
              <h5 className="section-title black">Security</h5>
              {canWrite && (
              <ActionMenu
                trigger={<img src={dropdownIcon} alt="Options" width={26} height={26} className="pointer iconStyleWithWhiteFilter" />}
                menuItems={securityActions}
                Id={userId}
              />
              )}
            </div>
            <div className="details-grid mt-3">
              <div className="profile-detail-item">
                <label>Password</label>
                <p><i className="bi bi-lock me-2"></i>********</p>
              </div>
            </div>
          </div>

          {/* Modals */}
          {showEditModal && (
            <EditProfileModal
              isOpen={showEditModal}
              onClose={() => setShowEditModal(false)}
              userId={userId}
              refresh={fetchProfile}
            />
          )}
          {showResetModal && (
            <ResetPasswordModal
              isOpen={showResetModal}
              onClose={() => setShowResetModal(false)}
              userId={userId}
            />
          )}
        </>
      )}
    </div>
    </PermissionGuard>
  );
};

export default MyProfileComponent;


